import { MdArrowDropDown } from "react-icons/md";
import FilterDropdownList from "./FilterDropdownList";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

interface FilterPillProps {
  pilltext: string;
  options: { text: string; value: string }[];
  selectedOptions: string[];
  setSelectedOptions: React.Dispatch<React.SetStateAction<string[]>>;
}

const FilterPill: React.FC<FilterPillProps> = ({
  pilltext,
  options,
  selectedOptions,
  setSelectedOptions,
}) => {
  // States definition
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <div className="relative">
      <div
        className="pl-4 pr-3 py-2 bg-neutral-50 hover:bg-neutral-100 ease-in-out duration-150 rounded-full inline-flex justify-center items-center gap-2 cursor-pointer relative"
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <div className="justify-start text-neutral-700 text-sm font-normal font-sans leading-none select-none">
          {pilltext}
        </div>
        {selectedOptions.length > 0 && (
          <div className="px-1 py-0.5 bg-neutral-700 rounded-[32px] inline-flex justify-start items-center gap-2">
            <div className="text-center justify-start text-neutral-50 text-[10px] font-normal font-sans uppercase leading-3 tracking-wide">
              {selectedOptions.length}
            </div>
          </div>
        )}
        <motion.div
          initial={{ rotate: 0 }}
          animate={{ rotate: showDropdown ? -180 : 0 }}
          className="w-4 h-4 relative"
        >
          <MdArrowDropDown className="w-4 h-4 fill-neutral-700" />
        </motion.div>
      </div>
      <AnimatePresence>
        {showDropdown && (
          <>
            <div
              className="fixed top-0 left-0 w-screen h-screen z-20"
              onClick={() => setShowDropdown(false)}
            />
            <FilterDropdownList
              options={options}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
            />
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FilterPill;
